import { render, staticRenderFns } from "./modalTareaDetalle.vue?vue&type=template&id=93ee56a6&"
import script from "./modalTareaDetalle.vue?vue&type=script&lang=js&"
export * from "./modalTareaDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports